import React from "react";
import { connect } from "react-redux";
import { MainTaskDetailContainerStyled } from "./styled";
import { withRouter } from "navigations/withRouter";
import { ROUTE_PATH } from "utils/constants/routePath";
import { scrollToTopPageFN } from "utils/functions/scrollTopPage";
import { portalService } from "apiServices";
import { toast } from "react-toastify";
import { Displays, Forms, Modals } from "components";

class MainTaskDetailContainer extends React.Component {
  state = {
    isLoading: true,
    isCreate: false,
  };

  componentDidMount() {
    scrollToTopPageFN();
    if (this.props.router.params.id !== "create") {
      this.fetchData();
    } else {
      this.setState({
        isLoading: false,
        isCreate: true,
      });
    }
  }

  fetchData = async () => {
    let res = await portalService.GET_MAIN_TASK_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      this.setState({
        initialValues: res.data,
        productDetail: {
          cus_first_name: res.data.cus_first_name,
          cus_last_name: res.data.cus_last_name,
          cus_phone_number: res.data.cus_phone_number,
          product_id:
            res.data.warranty_type === "1"
              ? res.data.product_warranty_ref_id
              : res.data.instrument_ref_id,
          instrument_type_code: res.data.instrument_type_code,
          instrument_type_en: res.data.instrument_type_en,
          instrument_type_th: res.data.instrument_type_th,
          product_code: res.data.product_code,
          product_en: res.data.product_en,
          product_th: res.data.product_th,
          product_brand: res.data.instrument_brand,
          product_model: res.data.instrument_model,
          product_series: res.data.instrument_series,
          product_serial_no: res.data.instrument_serial_no,
        },
        isLoading: false,
      });
    }
  };

  // FLOW DELETE
  // =============================
  // =============================
  handleDelete = () => {
    this.setState({
      renderModal: (
        <Displays.CofirmBox
          label="คุณต้องการลบใช่หรือไม่ ?"
          labelBtn1="Confirm"
          labelBtn2="Cancel"
          onAction1={this.deleteAction}
          onAction2={this.handleCloseModal}
        />
      ),
    });
  };
  deleteAction = async () => {
    this.setState({
      isBgLoading: true,
    });
    let res = await portalService.DELETE_REWARD_DETAIL(
      this.props.router.params.id
    );
    if (res && res.status === 200) {
      toast.success("ลบสำเร็จ");
      this.handleNextStep();
    } else {
      toast.error("ลบไม่สำรเร็จ");
    }
  };

  handleCloseModal = () => {
    this.setState({
      renderModal: null,
    });
  };

  handleLoadProductWarrantyBySn = async (value) => {
    this.setState({
      productDetail: {
        customer_id: value.customer_ref_id,
        cus_first_name: value.first_name,
        cus_last_name: value.last_name,
        cus_phone_number: value.phone_number,
        member_type: value.member_type,
        product_id: value._id,
        instrument_type_code: value.pd_dep_code,
        instrument_type_en: value.pd_dep_desc + "-" + value.pd_cat02_desc,
        instrument_type_th: value.pd_dep_desc + "-" + value.pd_cat02_desc,
        product_code: value.pd_cat03_code,
        product_en: value.pd_cat03_desc,
        product_th: value.pd_cat03_desc,
        product_brand: "yamaha",
        product_model: value.model_code,
        product_series: value.description,
        product_serial_no: value.serial_no,
      },
    });
  };

  handleLoadInstrument = async (value) => {
    this.setState({
      productDetail: {
        customer_id: value.customer_ref_id,
        cus_first_name: value.customer_first_name,
        cus_last_name: value.customer_last_name,
        cus_phone_number: value.customer_phone_number,
        member_type: value.member_type,
        product_id: value._id,
        instrument_type_code: value.instrument_type_code,
        instrument_type_en: value.instrument_type_en,
        instrument_type_th: value.instrument_type_th,
        product_code: value.product_code,
        product_en: value.product_en,
        product_th: value.product_th,
        product_brand: value.brand,
        product_model: value.model,
        product_series: value.series,
        product_serial_no: value.serial_no,
      },
    });
  };

  // FLOW SUBMIT
  // =============================
  // =============================
  handleSubmit = async (values) => {
    const { productDetail } = this.state;
    this.setState({
      isBgLoading: true,
    });
    let params = {
      ...values,
      customer_ref_id: productDetail.customer_id,
      cus_first_name: productDetail.cus_first_name,
      cus_last_name: productDetail.cus_last_name,
      cus_phone_number: productDetail.cus_phone_number,
      member_type: productDetail.member_type,
      instrument_type_code: productDetail.instrument_type_code,
      instrument_type_en: productDetail.instrument_type_en,
      instrument_type_th: productDetail.instrument_type_th,
      product_code: productDetail.product_code,
      product_en: productDetail.product_en,
      product_th: productDetail.product_th,
      instrument_brand: productDetail.product_brand,
      instrument_model: productDetail.product_model,
      instrument_series: productDetail.product_series,
      instrument_serial_no: productDetail.product_serial_no,
    };
    if (values.warranty_type === "1") {
      params.product_warranty_ref_id = productDetail.product_id;
    }
    if (values.warranty_type === "2") {
      params.instrument_ref_id = productDetail.product_id;
    }
    let res =
      this.props.router.params.id === "create"
        ? await portalService.POST_MAIN_TASK_DETAIL(params)
        : await portalService.PUT_MAIN_TASK_UPDATE(
            this.props.router.params.id,
            params
          );
    if (res && res.status === 200) {
      toast.success("อัพเดตสำเร็จ");
      this.handleNextStep();
    } else {
      this.setState({
        isBgLoading: false,
      });
      toast.error("อัพเดตไม่สำเร็จ");
    }
  };

  handleCancel = () => {
    this.props.router.navigate(-1);
  };

  handleNextStep = () => {
    this.props.router.navigate(ROUTE_PATH.SERVICE_TASK);
  };

  render() {
    const { authenRedux } = this.props;
    const {
      isLoading,
      initialValues,
      isBgLoading,
      productDetail,
      renderModal,
      isCreate,
    } = this.state;
    const permission = !authenRedux
      ? false
      : authenRedux?.permission.find((e) => e.menu_key === "reward");
    return (
      <MainTaskDetailContainerStyled>
        <Displays.BGLoading visible={isBgLoading} />
        {isLoading ? (
          <div className="loading_show">
            <Displays.Loading theme_standard_loading />
          </div>
        ) : (
          <>
            {isCreate ? (
              <div className="title">New Main Task</div>
            ) : (
              <div className="title">Main Task</div>
            )}
            <Forms.MainTaskForm
              initialValues={initialValues}
              permission={permission}
              productDetail={productDetail}
              onLoadProductWarrantyBySn={this.handleLoadProductWarrantyBySn}
              onLoadInstrument={this.handleLoadInstrument}
              onCancel={this.handleCancel}
              onDelete={this.handleDelete}
              onSubmit={this.handleSubmit}
            />
          </>
        )}
        <Modals.BodyEmpty
          isShowModal={renderModal}
          onCloseModal={this.handleCloseModal}
        >
          {renderModal}
        </Modals.BodyEmpty>
      </MainTaskDetailContainerStyled>
    );
  }
}

const mapStateToProps = (state) => ({
  authenRedux: state.authenRedux,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MainTaskDetailContainer));
